import type { FC } from "react"

import { PalletHoldAction } from "../../constants"

import ConfirmationDialog from "@/components/common/Modals/ConfirmationDialog"

const ACTION_TO_COPY: Record<PalletHoldAction, { title: string; content: string; confirmLabel: string }> = {
  [PalletHoldAction.Put]: {
    title: "Put Pallet on Hold?",
    content:
      "Putting this pallet on hold will place lots on this pallet on hold. These lots will not be auto-assigned for fulfillment while the hold is active. Users with lot override permission can still manually assign these lots if required.",
    confirmLabel: "Put Pallet on Hold",
  },
  [PalletHoldAction.Release]: {
    title: "Release Pallet Hold?",
    content:
      "Releasing the pallet hold will make the lots on this pallet available for normal fulfillment assignment again, unless they are still restricted by another hold or quality status.",
    confirmLabel: "Release Pallet Hold",
  },
}

interface ProductInventoryPalletHoldDialogProps {
  action: PalletHoldAction
  loading: boolean
  onClose: () => void
  onConfirm: () => void
}

export const ProductInventoryPalletHoldDialog: FC<ProductInventoryPalletHoldDialogProps> = ({
  action,
  loading,
  onClose,
  onConfirm,
}) => {
  const { title, content, confirmLabel } = ACTION_TO_COPY[action]

  const handleClose = () => {
    if (!loading) onClose()
  }

  return (
    <ConfirmationDialog
      title={title}
      content={content}
      closeLabel='Cancel'
      confirmLabel={confirmLabel}
      confirmDisabled={loading}
      testIdPrefix='product-inventory-pallet.hold-dialog'
      onClose={handleClose}
      onConfirm={onConfirm}
    />
  )
}
